;var FilterCards = function( content, filterList ) {

  $.each( content, function( i ) {
    if ( filterList.length ) {
      content[i].filtered = false;

      if ( content[i].generos != undefined || content[i].generos != null ) {
        for ( var j = 0; j < content[i].generos.length; j++ ) {
          if ( filterList.indexOf( content[i].generos[j] ) > -1 ) {
            content[i].filtered = true;
            break;
          }
        }
      }
    } else {
      content[i].filtered = true;
    }
  });

  CardsPosition.set( 0 );

};
